
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPipeStraight as ObiPipeStraightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pipe-straight.js';
 
 
 

 
 export const ObiPipeStraight = createComponent({
   react: React,
   tagName: 'obi-pipe-straight',
   elementClass: ObiPipeStraightElement,
   events: {
     
   }
  });
 
 